import { render } from "./DashBoardView.vue?vue&type=template&id=42956601"
import script from "./DashBoardView.vue?vue&type=script&lang=js"
export * from "./DashBoardView.vue?vue&type=script&lang=js"

import "./DashBoardView.vue?vue&type=style&index=0&id=42956601&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__